<template>
  <section class="learning-paths">
    <LearningPathsByLearningArea
      v-for="area in [...primaryAreas, ...secondaryAreas]"
      :key="area.id"
      :area="area.name"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import LearningPathsByLearningArea from '@/components/all-learning-paths/LearningPathsByLearningArea.vue'

export default {
  name: 'AllLearningPaths',
  metaInfo() {
    const { title } = this
    return {
      title: `INE - Learning Paths`,
      meta: [
        {
          vmid: 'learning-paths',
          name: 'description',
          content: title,
        },
      ],
    }
  },
  components: {
    LearningPathsByLearningArea,
  },
  data() {
    return {
      title: `INE Learning Paths provide a clear trajectory through certain
        certification tracks, ensuring that you're watching the right videos and
        learning the vital topologies necessary to pass your exams.`,
    }
  },
  computed: {
    ...mapGetters({
      primaryAreas: 'learningAreas/primaryAreas',
      secondaryAreas: 'learningAreas/secondaryAreas',
    }),
  },
}
</script>

<style lang="scss">
.learning-paths {
  padding: 100px 10px 50px 10px;
  @include mobile {
    padding: 100px 25px 50px 25px;
  }
  @include desktop {
    padding: 100px 75px;
  }
  @include lg-desktop {
    padding: 100px 125px;
  }
}
</style>
